import React, { useMemo } from 'react';
import { FilterProps } from '@/components/_common/Filters/Filter';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { applyFilter } from '@/redux/slices/dataTableSlice';
import CalendarDropdownMultiSelect from '@/components/Focus/common/CalendarDropdownMultiSelect';

interface Props {
  label: string;
  type: string;
  filter: FilterProps;
  selectedItems: string[];
}

const CalendarFilterMultiSelect: React.FC<Props> = ({ label, type, selectedItems, filter }) => {
  const dispatch = useAppDispatch();
  const optionsRecord: Record<string, string> = useAppSelector(filter.options);
  const options = useMemo(() => Object.entries(optionsRecord).map(([value, label]) => ({ label, value })), [optionsRecord]);

  const handleChange = (key: string, value: boolean) => {
    const selections = value ? [...selectedItems, key] : selectedItems.filter((item) => item !== key);
    dispatch(applyFilter({ type, selections }));
  };

  const handleClear = () => {
    dispatch(applyFilter({ type, selections: [] }));
  };

  return (
    <CalendarDropdownMultiSelect
      label={label}
      showLabelInDropdown
      options={options}
      selectedItems={selectedItems}
      onChange={handleChange}
      onClear={handleClear}
    />
  );
};

export default CalendarFilterMultiSelect;
